import type { JSX } from 'react';
import { useState } from 'react';
import { Button } from '@/components/ui/button.js';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog.js';
import { Field } from '@/components/ui/field.js';
import { Textarea } from '@/components/ui/input.js';

export interface IgnoreInvoiceDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  description: string;
  isSubmitting?: boolean;
  onConfirm: (reason: string) => void;
}

/** « Ignorer » une facture Pennylane, motif obligatoire (`02` §7). */
export function IgnoreInvoiceDialog({
  open,
  onOpenChange,
  description,
  isSubmitting = false,
  onConfirm,
}: IgnoreInvoiceDialogProps): JSX.Element {
  const [reason, setReason] = useState('');

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) {
          setReason('');
        }
        onOpenChange(next);
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Ignorer cette facture</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <Field label="Motif" htmlFor="ignore-invoice-reason">
          <Textarea
            id="ignore-invoice-reason"
            value={reason}
            onChange={(event) => {
              setReason(event.target.value);
            }}
          />
        </Field>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              onOpenChange(false);
            }}
          >
            Annuler
          </Button>
          <Button
            type="button"
            variant="destructive"
            disabled={reason.trim().length === 0}
            isLoading={isSubmitting}
            onClick={() => {
              onConfirm(reason.trim());
            }}
          >
            Ignorer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
